<template>
  <nav class="navbar navbar-expand-md navbar-light" id="header" th:fragment="header">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navBar" aria-controls="navBar" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse order-0" id="navBar">
          <ul class="navbar-nav mr-auto">
              <li class="name-item">
                <router-link v-bind:to="'/'" class="nav-link">Home</router-link>
              </li>
              <li class="name-item">
                <router-link v-bind:to="'/photos'" class="nav-link">Photos</router-link>
              </li>
              <li class="name-item">
                <router-link v-bind:to="'/posts'" class="nav-link">Posts</router-link>
              </li>
          </ul>
          <ul class="navbar-nav order-2">
              <li class="name-item">
                <router-link v-bind:to="'/contact'" class="nav-link">Contact</router-link>
              </li>
          </ul>
      </div>
  </nav>
</template>
<script>
export default {
  name: 'navbar',
  data () {
    return {
      count: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue